import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field } from "formik"; import React, { useState } from "react"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Table } from "react-bootstrap"; import { ExportToExcelButton, generatePDF, GetDetails, LabelHeader, loginuser, ModuleHeader, todayDate } from "../../utils/commonFunctions";
import { store } from "../../../App";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import moment from "moment-timezone";
import { Link } from "@material-ui/core";
import { AiOutlineSearch } from "react-icons/ai";

const TrailBalanceReportWithOBs = () => {
    const [tableEnable, settableEnable] = useState(false);
    const [distList, setDistList] = useState([]);
    const [trailData, setTrailData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const formik4 = useFormik({
        initialValues: { fromDate: "", toDate: "", district: "state", },
        validate: (values) => {
            const errors = {};
            if (!values.fromDate) { errors.fromDate = "select fromDate"; }
            if (!values.toDate) { errors.toDate = "select toDate"; }
            if (!values.district) { errors.district = "select jv type"; }
            return errors;
        },
        onSubmit: () => {
            store.dispatch({ type: "SHOW_SPINNER" });
            let params = { "fromDate": moment(formik4.values.fromDate).format("DD/MM/YYYY"), "toDate": moment(formik4.values.toDate).format("DD/MM/YYYY"), "review_flag": "TrailBalance", "security_id": formik4.values.district };
            HousingService.TrailBalanceReportWithOBs(params).then((res) => {
                if (res && res.data && res.data?.length > 0) {
                    setTrailData(res.data)
                }
                else { setTrailData([]); }
            }).catch((error) => {
                console.error("Error fetching data:", error);
            }).finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
                settableEnable(true);
            })
        }
    });
    React.useEffect(() => {
        HousingService.CGG_District().then((res) => {
            if (res.data) {
                // setDistData(res.data); 
                let options = res.data.map((item, i) => { return (<option key={i} value={item.code}> {item.name} </option>); }); setDistList(options);
            }
        });
    }, []);

    const filteredtrailData = searchText.length > 0 ? trailData?.filter((item) => { return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase())); })); }) : trailData;


    const handleSearch = (event) => {
        setSearchText(event.target.value);
    };
    return (
        <>
            <NavigationServicesHeader />
            <ModuleHeader title="Trail Balance With OB's" />
            <OFMSUI.Container className="outer-page-content-container " fluid style={{ width: "90%" }} >
                <FormikProvider value={formik4}>
                    <Form onSubmit={formik4.handleSubmit}>
                        <OFMSUI.Row>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                <LabelHeader title="From Date" />
                                <Field name="fromDate" className={formik4.touched.fromDate && formik4.errors.fromDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik4.handleChange(e)} max={todayDate} />
                                {formik4.touched.fromDate && formik4.errors.fromDate ? (<div className="invalid-feedback"> {formik4.errors.fromDate} </div>) : null} </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}> <LabelHeader title="To Date" />
                                <Field name="toDate" className={formik4.touched.toDate && formik4.errors.toDate ? "form-control is-invalid" : "form-control"} type="date" min={formik4.values.fromDate} max={todayDate} onChange={(e) => formik4.handleChange(e)} /> {formik4.touched.toDate && formik4.errors.toDate ? (<div className="invalid-feedback">{formik4.errors.toDate}</div>) : null} </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}> <LabelHeader title="District" /> <Field component="select" name="district" className={formik4.touched.district && formik4.errors.district ? "form-control is-invalid" : "form-control"} onChange={(e) => formik4.handleChange(e)} > {formik4.touched.district && formik4.errors.district ? (<div className="invalid-feedback"> {formik4.errors.district} </div>) : null} {loginuser.startsWith("DH") ? (<option value="0">Select</option>) : (<option value="state">State</option>)} {distList} </Field> </OFMSUI.Col>
                            <GetDetails />
                        </OFMSUI.Row>

                        {tableEnable && (
                            <>
                                <OFMSUI.Row>

                                    <OFMSUI.Col xs={12} sm={12} md={9} lg={12} xl={12} xxl={12} className=" mb-2 float-end" >
                                        <button type="button" className="btn btn-danger btn-sm"
                                            onClick={() => generatePDF("my-table", "Trail Balance With OB's", "TrailBalanceWithOBs.pdf", 12)}
                                            style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                        <ExportToExcelButton tableId="my-table" filename="TrailBalanceWithOBs" sheet="tablexls" buttonText="Excel" />
                                    </OFMSUI.Col>
                                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                                        <div className="input-group"> <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                                            <input type="text" id="#filterInput" placeholder="Search " style={{ width: "25%" }} className="form-control input-lg" value={searchText} onChange={handleSearch} ></input> </div>
                                    </OFMSUI.Col>
                                </OFMSUI.Row>
                                <div style={{ overflow: "auto", height: "1000px" }}>
                                    <Table striped bordered hover id="my-table">
                                        <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} > <tr> <td colSpan={12} style={{ textAlign: "center" }}> Trial Balance as on {moment(formik4.values.fromDate).format("DD-MM-YYYY")} and {moment(formik4.values.toDate).format("DD-MM-YYYY")} </td> </tr>
                                            <tr className="table_countshead">
                                                <th className="text-center">S.No.</th>
                                                <th> Head ID </th>
                                                <th> Head Name </th>
                                                <th className="text-center"> OB Debit</th>
                                                <th className="text-center"> OB Credit</th>
                                                <th className="text-center"> Debit</th>
                                                <th className="text-center"> Credit</th>
                                                <th className="text-center"> Net Debit </th>
                                                <th className="text-center"> Net Credit </th> </tr>
                                        </thead>
                                        <tbody>
                                            {filteredtrailData && filteredtrailData.length > 0 ? (filteredtrailData.map((filteredtrailData, i) => (
                                                <tr key={i}> <td className="text-center">{i + 1}</td>
                                                    <td>{filteredtrailData.headid}</td>
                                                    <td>{filteredtrailData.headname}</td>

                                                    <td className="text-right">{parseFloat(filteredtrailData.obdebit).toFixed(2)}</td>
                                                    <td className="text-right">{parseFloat(filteredtrailData.obcredit).toFixed(2)}</td>

                                                    <td className="text-right">{parseFloat(filteredtrailData.debit).toFixed(2)}</td>
                                                    <td className="text-right">{parseFloat(filteredtrailData.credit).toFixed(2)}</td>
                                                    <td className="text-right">{parseFloat(filteredtrailData.netdebit).toFixed(2)}</td>
                                                    <td className="text-right">{parseFloat(filteredtrailData.netcredit).toFixed(2)}</td>
                                                </tr>))
                                            ) : (<tr> <td colSpan="9" style={{ textAlign: "center" }}> No data found </td> </tr>)}
                                        </tbody>

                                        <tfoot style={{ position: "sticky", bottom: "0px" }}>
                                            <tr className="table_countshead" style={{ textAlign: "end" }}>
                                                <td colSpan={3} > Total Amount in Rs </td>
                                                <td >{filteredtrailData?.reduce((a, v) => a + parseFloat(v.obdebit || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                <td >{filteredtrailData?.reduce((a, v) => a + parseFloat(v.obcredit || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                <td >{filteredtrailData?.reduce((a, v) => a + parseFloat(v.debit || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                <td >{filteredtrailData?.reduce((a, v) => a + parseFloat(v.credit || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                <td >{filteredtrailData?.reduce((a, v) => a + parseFloat(v.netdebit || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                <td >{filteredtrailData?.reduce((a, v) => a + parseFloat(v.netcredit || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                            </tr>
                                        </tfoot>
                                    </Table>
                                </div>

                            </>


                        )}
                    </Form>
                </FormikProvider>
            </OFMSUI.Container>
        </>
    );
};
export default TrailBalanceReportWithOBs;
